import constant from "../helper/constant";
import { getUUID } from "../helper/helper";
import http, { crewBoHttp } from "./../helper/http";

export const getTemplateList = (params) =>
  http.get(constant.API.AI_MODEL.GET_AI_TEMPLATES, { params });

export const createNewTemplateWithData = (payload) =>
  http.post(`${constant.API.AI_MODEL.GET_AI_TEMPLATES}/upload`, payload);

export const createNewTemplateWithoutData = (payload) =>
  http.post(`${constant.API.AI_MODEL.GET_AI_TEMPLATES}`, payload);

export const updateExistingTemplate = (payload) =>
  http.put(`${constant.API.AI_MODEL.GET_AI_TEMPLATES}/${payload.id}`, payload);

export const deleteDraftTemplate = (id) =>
  http.delete(`${constant.API.AI_MODEL.GET_AI_TEMPLATES}/${id}`);

export const getModelList = (id) =>
  http.get(`${constant.API.AI_MODEL.GET_AI_TEMPLATES}/${id}`);

export const getDepartmentList = (params) =>
  http.get(constant.API.AI_MODEL.GET_DEPARTMENTS, { params });

export const getTaskListForDepartment = (params) =>
  http.get(constant.API.AI_MODEL.GET_TASKS, { params });

export const getAIValueData = (payload) =>
  http.post(constant.API.AI_MODEL.GET_AI_VALUE, payload);

export const getAIValueByModel = (id) =>
  http.get(constant.API.AI_MODEL.GET_AI_VALUE_PROFIT.replace("{id}", id));

export const getAIRoadmapData = (id) =>
  http.get(constant.API.AI_MODEL.GET_ROAD_MAP.replace("{id}", id));

export const getModelDetailForId = (id) =>
  http.get(constant.API.AI_MODEL.GET_MODEL_DETAILS.replace("{id}", id));

export const getAIDataWorkflows = () =>
  http.get(constant.API.AI_MODEL.GET_AI_DATA_WORKFLOW);

export const getAIDataTargets = () =>
  http.get(constant.API.AI_MODEL.GET_AI_DATA_TARGET);

export const getAIDataFeatures = () =>
  http.get(constant.API.AI_MODEL.GET_AI_DATA_FEATURE);

export const getAIDataUploadStatus = (id) =>
  http.get(constant.API.AI_MODEL.GET_AI_DATA_UPLOAD_STATUS.replace("{id}", id));

export const getAIPredictLookup = (id) =>
  http.get(constant.API.AI_MODEL.GET_AI_PREDICT_LOOKUP.replace("{id}", id));

export const triggerModelProcess = (id, payload) =>
  http.post(`${constant.API.AI_MODEL.TRIGGER_MODEL_PROCESS}/${id}`, payload);

export const getTrainingModel = (id) =>
  http.get(`${constant.API.AI_MODEL.TRANING_MODEL}/${id}`);

export const getSocialMediaModel = (id) =>
  http.get(`${constant.API.AI_MODEL.SOCIAL_MEDIA_MODEL}/${id}`);

export const saveTrainingModel = (payload, isUpdate) => {
  if (isUpdate) updateTrainingModel(payload);
  return http.post(constant.API.AI_MODEL.TRANING_MODEL, payload);
};

export const updateTrainingModel = (payload) =>
  http.put(`${constant.API.AI_MODEL.TRANING_MODEL}/${payload.id}`, payload);

export const generateProcessor = () =>
  http.get(
    `${constant.API.AI_MODEL.DOCUMENT_AI_PREDICTION}/createprocessor/${getUUID()}`
  );

export const saveSocialMediaModel = (payload, isUpdate) => {
  if (isUpdate) return updateSocialMediaModel(payload);
  return http.post(constant.API.AI_MODEL.SOCIAL_MEDIA_MODEL, payload);
};

export const updateSocialMediaModel = (payload) =>
  http.put(
    `${constant.API.AI_MODEL.SOCIAL_MEDIA_MODEL}/${payload.id}`,
    payload
  );

export const getSocialMediaSentiment = (payload) => {
  const { templateId, taskId } = payload;
  return http.get(
    `${constant.API.AI_MODEL.SOCIAL_MEDIA_PREDICTION_SENTIMENT}/${templateId}/${taskId}`
  );
};

export const getSocialMediaReviews = (payload) => {
  const { templateId, taskId, isNegative } = payload;
  const params = isNegative ? { type: "lowest_rating" } : {};
  return http.get(
    `${constant.API.AI_MODEL.SOCIAL_MEDIA_PREDICTION_REVIEW}/${templateId}/${taskId}/${1}`,
    { params }
  );
};

export const getSocialMediaQuery = (payload) => {
  const { templateId, taskId } = payload;
  return http.post(
    `${constant.API.AI_MODEL.SOCIAL_MEDIA_PREDICTION_QUERY}/${templateId}/${taskId}`,
    payload
  );
};

export const createSocialAds = (payload, taskId) =>
  http.post(
    `${constant.API.AI_MODEL.SOCIAL_MEDIA_CREATE_AD}/${taskId}`,
    payload
  );

export const createSocialImages = (payload, taskId) =>
  http.post(
    `${constant.API.AI_MODEL.SOCIAL_MEDIA_CREATE_IMAGES}/${taskId}`,
    payload
  );

export const getRegressionData = (templateId, taskId) =>
  http.get(
    `${constant.API.AI_MODEL.REGRESSION_GET_DATA}/${templateId}/${taskId}`
  );

export const triggerEmail = (templateId, payload) =>
  http.post(`${constant.API.AI_MODEL.SEND_EMAIL}/${templateId}`, payload);

export const postRegressionData = (templateId, taskId, payload) =>
  http.post(
    `${constant.API.AI_MODEL.REGRESSION_GET_DATA}/${templateId}/${taskId}`,
    payload
  );

export const uploadRegressionData = (templateId, taskId, payload) =>
  http.post(
    `${constant.API.AI_MODEL.REGRESSION_UPLOAD_DATA}/${templateId}/${taskId}`,
    payload
  );

export const postImagePrediction = (templateId, taskId, payload) =>
  http.post(
    `${constant.API.AI_MODEL.REGRESSION_GET_DATA}/${templateId}/${taskId}`,
    payload
  );

export const getImagePrediction = (templateId, taskId) =>
  http.get(
    `${constant.API.AI_MODEL.REGRESSION_GET_DATA}/${templateId}/${taskId}`
  );

export const getTextFromImage = (payload) =>
  http.post(`${constant.API.AI_MODEL.EXTRACT_TEXT_FROM_IMAGE}`, payload);

export const submitMultiUploadRequest = (payload) =>
  http.post(`${constant.API.AI_MODEL.MULTI_UPLOAD_REQUEST}`, payload);

export const getDocumentAIPrediction = (templateId, taskId) =>
  http.get(
    `${constant.API.AI_MODEL.DOCUMENT_AI_PREDICTION}/${templateId}/${taskId}`
  );

export const postDocumentPrediction = (templateId, taskId, payload) =>
  http.post(
    `${constant.API.AI_MODEL.DOCUMENT_AI_PREDICTION}/upload/${templateId}/${taskId}`,
    payload
  );

export const updateDocumentPrediction = (templateId, id, payload) =>
  http.put(
    `${constant.API.AI_MODEL.DOCUMENT_AI_PREDICTION}/${templateId}/${id}`,
    payload
  );

export const getKnowledgeAIPrediction = (templateId, taskId) =>
  http.get(
    `${constant.API.AI_MODEL.KNOWLEDGE_AI_PREDICTION}/${templateId}/${taskId}`
  );

export const requestKnowledgePrediction = (templateId, taskId, payload) =>
  http.post(
    `${constant.API.AI_MODEL.KNOWLEDGE_AI_PREDICTION}/${templateId}/${taskId}`,
    payload
  );

export const requestAutomatedTargets = (payload) =>
  http.post(
    `${constant.API.AI_MODEL.TRANING_MODEL}/autopopulatefields`,
    payload
  );

export const getEvaluateAIData = (templateId, id) =>
  http.get(
    `${constant.API.AI_MODEL.REGRESSION_GET_DATA}/${templateId}/${id}/evaluate`
  );

export const getDynamicChartTypes = (templateId, id) =>
  http.get(
    `${constant.API.AI_MODEL.REGRESSION_GET_DATA}/${templateId}/${id}/explain`
  );

export const getPredictionExplainData = (templateId, id) =>
  http.get(
    `${constant.API.AI_MODEL.REGRESSION_GET_DATA}/${templateId}/${id}/explaindata`
  );

export const getTimeSeriesPrediction = (templateId, id) =>
  http.get(
    `${constant.API.AI_MODEL.REGRESSION_GET_DATA}/batch/${templateId}/${id}`
  );

export const postTimeSeriesPrediction = (templateId, id, payload) =>
  http.post(
    `${constant.API.AI_MODEL.REGRESSION_GET_DATA}/batch/${templateId}/${id}`,
    payload
  );

//Business overview
export const createBusinessOverview = (payload) =>
  crewBoHttp.post(`${constant.API.AI_MODEL.GENERATE_BO_REPORT}`, payload);

export const getBusinessOverview = (params) =>
  http.get(`${constant.API.AUTH.ORG}/orginfo`, { params });

export const createDynamicWorkflow = (payload) =>
  http.post(`${constant.API.AI_MODEL.GET_AI_TEMPLATES}/autocreate`, payload);

export const triggerOtherOrgInfo = () =>
  http.post(`${constant.API.AUTH.ORG}/orginfo_others`);

//Chatbot APIs
export const postChatboxQuestion = (payload) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}/queryanswer`, payload);

export const getChatboxQuestion = () =>
  http.get(`${constant.API.AI_MODEL.ASK_ME}/listconversation`);

export const getChatboxQuestionDetails = (params) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}/getConversationData`, params);

export const deleteChatFile = (data) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}/deletedatastore`, data);

export const deleteChatHistory = (data) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}/deleteconversation`, data);

export const uploadChatbotFile = (payload) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}/uploaddatastore`, payload);

export const getChatbotPastFiles = (params) =>
  http.get(`${constant.API.AI_MODEL.ASK_ME}/listdatastore`, { params });

export const getSignedFile = (payload) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}/getsignedurl`, payload);

export const getUserList = () =>
  http.get(`${constant.API.AUTH.ORG}/findAllUsers`);

export const addUser = (payload) =>
  http.post(`${constant.API.AUTH.ORG}/createUser`, payload);

export const updateUser = (payload) =>
  http.post(`${constant.API.AUTH.ORG}/updateRole`, payload);

export const deleteUser = (payload) =>
  http.post(`${constant.API.AUTH.ORG}/deleteUser`, payload);

//ASK ME APIS
export const getTaskForQuery = (payload) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}/gettasksforquery`, payload);

export const getWorkflowForQuery = (payload) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}/getmodelforquery`, payload);

export const createAskMeWorkflow = (payload) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}/createautomatic`, payload);

export const getDepartmentSuggestedTasks = (payload) =>
  http.post(
    `${constant.API.AI_MODEL.GET_AI_TEMPLATES}/getdepartmentinfo`,
    payload
  );

export const checkForTemplateName = (name) =>
  http.get(`${constant.API.AI_MODEL.GET_AI_TEMPLATES}/uniquename/${name}`);

export const uploadChatFileWebUrl = (payload) =>
  http.get(`${constant.API.AI_MODEL.ASK_ME}`, payload);

export const getAgentTypes = () =>
  http.get(`${constant.API.AI_MODEL.AGENT_TYPE}`);

export const getAgentsAPI = () => http.get(`${constant.API.AI_MODEL.AGENT}`);

export const getRAGCorpusAPI = () => http.get(`${constant.API.AI_MODEL.RAG_CORPUS}`);

export const addRAGCorpusAPI = payload => http.post(`${constant.API.AI_MODEL.RAG_CORPUS}`, payload);

export const addRAGCorpusFileAPI = (payload, id) => http.post(`${constant.API.AI_MODEL.RAG_CORPUS}/${id}/files`, payload);

export const getAllModelsAPI = () =>
  http.get(`${constant.API.AI_MODEL.ASK_ME}/getAllApi`);

export const getAllModelsForAgentAPI = (agent) =>
  http.get(`${constant.API.AI_MODEL.AGENT}/${agent}`);

export const createAgentAPI = (payload, agent) => {
  if (agent) {
    return http.put(`${constant.API.AI_MODEL.AGENT}/${agent}`, payload);
  }
  return http.post(`${constant.API.AI_MODEL.AGENT}`, payload);
};

export const deleteAgentAPI = (id) => {
  return http.delete(`${constant.API.AI_MODEL.AGENT}/${id}`);
};

export const uploadAgentFileAPI = (payload) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}`, payload);

export const deleteAgentFileAPI = (params) =>
  http.delete(`${constant.API.AI_MODEL.ASK_ME}`, { params });

export const connectModelToAgentAPI = (payload) =>
  http.post(`${constant.API.AI_MODEL.ASK_ME}`, payload);

/** Visialuse AI */
export const getAnalyticsDashboardList = (templateId, taskId) =>
  http.get(
    constant.API.AI_MODEL.INFERENCE_DASHBOARD.replace(
      "{templateId}",
      templateId
    ).replace("{taskId}", taskId)
  );

export const getAnalyticsDashboardURL = (templateId, taskId, viewId) =>
  http.get(
    `${constant.API.AI_MODEL.INFERENCE_DASHBOARD_URL.replace(
      "{templateId}",
      templateId
    )
      .replace("{taskId}", taskId)
      .replace("{viewId}", viewId)}`
  );

export const createAnalyticsDashboard = (templateId, taskId) =>
  http.get(
    `${constant.API.AI_MODEL.CREATE_INFERENCE_DASHBOARD.replace(
      "{templateId}",
      templateId
    ).replace("{taskId}", taskId)}`
  );

export const createAnalyticsDashboardView = (templateId, taskId, viewId) =>
  http.get(
    `${constant.API.AI_MODEL.CREATE_INFERENCE_DASHBOARD_VIEW.replace(
      "{templateId}",
      templateId
    ).replace("{taskId}", taskId).replace("{viewId}", viewId)}`
  );


export const getWorkflowListAPI = () => http.get(constant.API.AI_MODEL.WORKFLOW);

export const getWorkflowInputTypesAPI = () => http.get(`${constant.API.AI_MODEL.WORKFLOW}/getinputs`);

export const getWorkflowAPI = id => http.get(`${constant.API.AI_MODEL.WORKFLOW}/${id}`);

export const getWorkflowExecutionResultAPI = payload => http.post(constant.API.AI_MODEL.WORKFLOW_EXECUTION_STEP_DATA, payload);
export const saveWorkflowExecutionResultAPI = payload => http.post(constant.API.AI_MODEL.SAVE_WORKFLOW_STEP_DATA, payload);

export const createWorkflowAPI = (payload, id) => {
  if (id) {
    return http.put(`${constant.API.AI_MODEL.WORKFLOW}/${id}`, payload);
  }
  return http.post(constant.API.AI_MODEL.WORKFLOW, payload);
}

export const deleteWorkflowAPI = id => http.delete(`${constant.API.AI_MODEL.WORKFLOW}/${id}`);

export const getWorkflowModelListAPI = () => http.get(constant.API.AI_MODEL.WORKFLOW_MODEL_LIST);

export const getWorkflowGenerativeModelListAPI = () => http.get(constant.API.AI_MODEL.WORKFLOW_GENERATIVE_MODEL_LIST);

export const getWorkflowLLMListAPI = () => http.get(constant.API.AI_MODEL.WORKFLOW_LLM_LIST);

export const getWorkflowExecutionListAPI = (params) => http.get(constant.API.AI_MODEL.WORKFLOW_EXECUTION_LIST, { params });

export const getWorkflowExecutionSchemaAPI = (payload) => http.post(constant.API.AI_MODEL.WORKFLOW_EXECUTION_SCHEMA, payload);

export const saveWorkflowExecutionData = (payload) => http.post(constant.API.AI_MODEL.SAVE_WORKFLOW_EXECUTION_DATA, payload);

export const executeWorkflowAPI = payload => http.post(constant.API.AI_MODEL.WORKFLOW_EXECUTION, payload);

export const approvalWorkflowAPI = (executionId, id) => http.get(`${constant.API.AI_MODEL.WORKFLOW_APPROVAL}/${executionId}/${id}`);

export const rejectWorkflowAPI = (executionId, id) => http.get(`${constant.API.AI_MODEL.WORKFLOW_REJECT}/${executionId}/${id}`);

export const executePendingWorkflowAPI = (payload) => http.post(constant.API.AI_MODEL.WORKFLOW_EXECUTE_PENDING_WORKFLOW, payload);

export const stopWorkflowExecutionAPI = (payload) => http.post(constant.API.AI_MODEL.WORKFLOW_STOP_WORKFLOW, payload);

export const getExecutionStatusAPI = payload => http.post(constant.API.AI_MODEL.GET_WORKFLOW_EXECUTION_STATUS, payload);

export const scheduleWorkflowAPI = payload => http.post(constant.API.AI_MODEL.GET_WORKFLOW_EXECUTION_STATUS, payload);

export const deleteScheduleWorkflowAPI = payload => http.post(constant.API.AI_MODEL.WORKFLOW_DELETE_SCHEDULE, payload);

export const getWorkflowLogsAPI = payload => http.post(constant.API.AI_MODEL.WORKFLOW_LOGS, payload);

export const saveWorkflowImageAPI = (payload, id) => http.post(`${constant.API.AI_MODEL.WORKFLOW_SAVE_IMAGE}/${id}`, payload);

export const getNodeStatusAPI = (id) => http.post(constant.API.AI_MODEL.WORKFLOW_NODE_STATUS, { id });

export const getCloudStorageFilesAPI = () => http.get(constant.API.AI_MODEL.WORKFLOW_CLOUD_FILES);

export const getAISensesDevicesAPI = () => http.get(constant.API.AI_MODEL.WORKFLOW_AISENSES_DEVICES);

export const getAISensesZonesAPI = (params) => http.get(constant.API.AI_MODEL.WORKFLOW_AISENSES_ZONES, { params });

export const getCloudStorageFileColumnAPI = (file) => http.post(constant.API.AI_MODEL.WORKFLOW_CLOUD_FILE_COLUMNS, { file });

export const getBusiness360DataAPI = (id = constant.businesOverview360) => {
  // return Promise.resolve(business360);
  return http.get(`${constant.API.AI_MODEL.BUSINESS_360_DATA}/${id}`);
};

export const getSummary360DataAPI = (params) => {
  return http.get(constant.API.AI_MODEL.SUMMARY_360_DATA, { params });
  // return Promise.resolve(summaryJSON);
};

export const getSummaryProductsAPI = (params) => {
  return http.get(constant.API.AI_MODEL.GET_PRODUCTS, { params });
  // return Promise.resolve(PRODUCTS);
};

export const getDashboardSchema = () => http.get(constant.API.AI_MODEL.DASHBOARD_SCHEMA);

export const getDashboardData = (params) => http.get(constant.API.AI_MODEL.DASHBOARD_DATA, { params });

export const getPricePredictionDashboard = (params) => http.get(constant.API.AI_MODEL.PRICE_PREDICTION_DASHBOARD, { params });

export const getBusinessEntityList = (params) => http.get(constant.API.AI_MODEL.BUSINESS_ORG_NAMES, { params });

export const getAIRecommendationsAPI = (params) => {
  return http.get(constant.API.AI_MODEL.AI_RECOMMENDATIONS, { params });
}

export const getSearchRecommendationsAPI = (query) => {
  // return http.get(constant.API.AI_MODEL.SEARCH_RECOMMENDATIONS, { params: { query } });
  const data = [
    { label: "Apple", group: "Fruits" },
    { label: "Banana", group: "Fruits" },
    { label: "Orange", group: "Junk" },
    { label: "Carrot", group: "Vegetables" },
    { label: "Broccoli", group: "Junk" },
    { label: "Spinach", group: "Vegetables" },
  ];
  return Promise.resolve(data.filter((item) => item.label.toLowerCase().includes(query.toLowerCase())));
}
export const getCustomDashboard = (params) => http.get(constant.API.AI_MODEL.CUSTOM_DASHBOARD, { params });

export const getCustomDashboardDetails = (params) => http.get(constant.API.AI_MODEL.CUSTOM_DASHBOARD_DETAIL, { params });

export const getCustomDashboardURL = (params) => http.get(constant.API.AI_MODEL.CUSTOM_DASHBOARD_URL, { params });

export const createCustomDashboard = (params) => http.get(constant.API.AI_MODEL.CREATE_CUSTOM_DASHBOARD, { params });

export const uploadWorkflowCustomDocumnet = (payload) =>
  http.post(constant.API.AI_MODEL.WORKFLOW_INPUT_FILE_UPLOAD, payload);

export const getImpartDashboardData = (params) => {
  return http.get(constant.API.AI_MODEL.IMPART_DASHBOARD_DATA, { params });
}

export const updateBusiness360Cell = (payload) => http.post(constant.API.AI_MODEL.WORKFLOW_UPDATE_BUSINESS_360_CELL, payload);

export const getDashboardVersionHistoryAPI = (params) => http.get(constant.API.AI_MODEL.DASHBOARD_VERSION_HISTORY, { params });

export const updateDashboardVersionHistoryAPI = (params) => http.get(constant.API.AI_MODEL.DASHBOARD_SET_DEFAULT_VERSION, { params });

export const updateShowHideBusiness360CellAPI = (payload) => http.post(constant.API.AI_MODEL.UPDATE_SHOW_HIDE_BUSINESS_360_CELL, payload);

export const deleteRowBusiness360CellAPI = (payload) => http.post(constant.API.AI_MODEL.DELETE_BUSINESS360_ITEM, payload);

export const moveRowBusiness360CellAPI = (payload) => http.post(constant.API.AI_MODEL.MOVE_BUSINESS360_ITEM, payload);

export const updateClientStatusAPI = (payload) => http.post(constant.API.AI_MODEL.UPDATE_CLIENT_STATUS, payload);

export const addBusiness360ItemAPI = (payload) => http.post(constant.API.AI_MODEL.ADD_BUSINESS_360_ITEM, payload);

export const getWorkflowAgentsAPI = (id) => http.get(`${constant.API.AI_MODEL.WORKFLOW_AGENTS}/${id}`);